/* eslint-disable import/no-anonymous-default-export */
// eslint-disable-next-line no-unused-vars
import client from '../../Components/Client';
import service from './service';

export const get = async (invitationId) => {
  const response = await service.get(`/invitations/${invitationId}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const acceptCompanyInvitation = async (payload) => {
  const response = await service.post(
    `/company-invitations/${payload.invitationId}/accept`,
    payload
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

const registerByInvitation = async (payload) => {
  const response = await service.postPublic(
    `/invitations/${payload.invitationId}/register`,
    payload
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

const distributorRegisterByInvitation = async (payload) => {
  const response = await service.postPublic(
    `/invitations/${payload.invitationId}/distributor-register`,
    payload
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const acceptUserInvitation = async (invitationId, payload) => {
  try {
    const response = await service.postPublic(`/invitations/${invitationId}/accept`, payload);

    if (response.status === 200) {
      const data = response.data;

      return data;
    }
  } catch (error) {
    throw error?.response?.data?.message || 'Oops! Something went wrong';
  }
};

// export const acceptFriendInvitation = async (invitationId, payload) => {
//   try {
//     const response = await service.postPublic(
//       `/invitations/${invitationId}/invite-friend-accept`,
//       payload
//     );

//     if (response.status === 200) {
//       const data = response.data;

//       return data;
//     }
//   } catch (error) {
//     throw error?.response?.data?.message || 'Oops! Something went wrong';
//   }
// };

export const checkInvitation = async (invitationId) => {
  const response = await service.getPublic(`/invitations/${invitationId}/invitation-check`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getInvitationDetails = async (payload) => {
  const response = await service.post(`/invitations/get-invite-details`, payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const acceptFriendInvitation = async (payload) => {
  const response = await service.post(`/invitations/invite-friend-accept`, payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const acceptInvitation = async (payload) => {
  const response = await service.post(`/invitations/accept`, payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export default {
  get,
  registerByInvitation,
  checkInvitation,
  distributorRegisterByInvitation,
  getInvitationDetails,
  acceptFriendInvitation,
  acceptInvitation,
};
